import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../api";
import { useAuth } from "../context/AuthContext";

export function useShop() {
  const { user, openAuth } = useAuth();
  const navigate = useNavigate();
  const [catalog, setCatalog] = useState([]);
  const [wishedIds, setWished] = useState([]);

  useEffect(() => { api.get("/content").then((r) => setCatalog(r.data)).catch(() => {}); }, []);

  const refreshWishlist = useCallback(async () => {
    if (!user) { setWished([]); return; }
    try { const { data } = await api.get("/journey"); setWished(data.map((x) => x.item_id)); } catch {}
  }, [user]);

  useEffect(() => { refreshWishlist(); }, [refreshWishlist]);

  const toggleWish = async (item) => {
    if (!user) { openAuth("login"); return; }
    const on = wishedIds.includes(item.id);
    try {
      if (on) { await api.delete(`/journey/${item.id}`); toast("Removed from wishlist"); }
      else { await api.post("/journey", { item_id: item.id, title: item.title, section: item.category }); toast.success("Added to wishlist"); }
      await refreshWishlist();
    } catch {}
  };

  const buy = async (item) => {
    if (!user) { openAuth("login"); return; }
    try {
      const { data } = await api.post("/checkout/session", { item_id: item.id, origin_url: window.location.origin });
      if (data.url) window.location.href = data.url;
    } catch { toast.error("Could not start checkout."); }
  };

  const partner = (item, region) => {
    const url = region === "us" ? item.affiliate_url_us
              : region === "uk" ? item.affiliate_url
              : (item.affiliate_url || item.affiliate_url_us);
    if (url) window.open(url, "_blank");
    else toast(`Trusted Partner: ${item.partner}`, { description: "Affiliate link to be added." });
  };

  const openItem = (item) => {
    const nlp = ["nlp_practitioner", "nlp_master_practitioner", "nlp_trainer_training"];
    if (nlp.includes(item.id)) navigate(`/nlp/${item.id}`);
    else if (item.category === "course") navigate(`/course/${item.id}`);
  };

  return { catalog, wishedIds, refreshWishlist, toggleWish, buy, partner, openItem, navigate, user };
}
